import React, { Component } from "react";
import { withRouter, Redirect } from "react-router-dom";
import { connect } from "react-redux";

import LoanInfoForm from "../forms/loan-info/loan-info-form.component";
import { getLoanDetails } from "../../actions/loans.actions";
import { changeCurrentStep } from "../../actions/processStep.actions";
import { getToken } from "../../actions/token.actions";
import { scrollTo } from "../../utils/smoothScroll";
import { convenienceFee } from "../../utils/content";

class LoanInfoComponent extends Component {
  constructor(props) {
    super(props);
    this.props.changeCurrentStep(1);
    this.submitForm = this.submitForm.bind(this);
  }

  componentDidMount() {
    if (this.props.token == null) {
      this.props.getToken();
    }
  }

  // Get a new token if the app is cancelled on this page and doesn't have a token
  componentDidUpdate(prevProps) {
    if (prevProps.token !== this.props.token && this.props.token == null) {
      this.props.getToken();
    }
  }

  submitForm(formName) {
    // this.props.history.push('/loan-payment')
    var self = this;
    if (
      window.location.origin.indexOf("localhost") != -1 ||
      window.location.origin.indexOf("int-payments.accredere.org") != -1 ||
      window.location.origin.indexOf("test-payments.accredere.org") != -1 ||
      window.location.origin.indexOf("stage-payments.laketrust.org") != -1
    ) {
      // if we're in a lower environment, dont bother getting a captcha token
      self.submitWithCaptchaToken(self, formName, "");
    } else {
      // ReCaptcha 3
      window.grecaptcha.ready(function () {
        window.grecaptcha
          .execute("6LdVHekUAAAAAPRqzyhts0xp9pIEJP_JMFvZnqK6", { action: "loanpayments" })
          .then((token) => {
            self.submitWithCaptchaToken(self, formName, token);
          });
      });
    }
  }

  submitWithCaptchaToken(self, formName, token) {
    let loanDetails = self.props.form[formName].values;
    loanDetails.email = loanDetails.email.trim();
    loanDetails.token = token;
    loanDetails.loanNumber = loanDetails.loanNumber.replace(/\s+/g, "");
    self.props.getLoanDetails(loanDetails);
    scrollTo(0, 1000);
  }

  render() {
    if (this.props.loans.PaymentAllowed === false) {
      return <Redirect to="/payment-unavailable" />;
    }
    if (this.props.loans.LoanNumber && !this.props.appStatus.paused) {
      return <Redirect to="/loan-payment" />;
    }
    return (
      <div className="container app-container">
        <LoanInfoForm submitForm={this.submitForm} />
        <div className="row">
          <div className="col-12">
            <div className="form-group disclosure">
              Payments made via routing and account number (ACH transfer) are allowed on installment
              loans only and may take up to 5 business days to process. Payments may be made using a
              Visa Debit Card or MasterCard Debit Card for a ${convenienceFee} convenience fee.
              Credit cards are not accepted for Lake Trust Credit Union loan payments. Payments made
              with your debit card will post to your account on the same business day if paid by
              7:30 p.m. EST Monday through Friday.
            </div>
          </div>
        </div>
      </div>
    );
  }
}

// Map global store to component props
const mapStateToProps = (state) => state;

// Hook up actions to component
const mapDispatchToProps = {
  changeCurrentStep,
  getLoanDetails,
  getToken,
};

//Connect to Redux store
const LoanInfo = withRouter(connect(mapStateToProps, mapDispatchToProps)(LoanInfoComponent));

export default LoanInfo;



// WEBPACK FOOTER //
// ./src/components/loan-info/loan-info.component.js